/**
 * wrapper around the HTML5 local storage API.
 * support JSON serialization de-serialization.
 *
 */

let storage, sessionStorage;
export default class AppStorage {

	constructor($window) {
		storage = $window.localStorage;
		sessionStorage = $window.sessionStorage;
	}

	setItem(key, item, onlyForSession = false) {
		try {
			sessionStorage.setItem(key, JSON.stringify(item));
			if (!onlyForSession) {
				storage.setItem(key, JSON.stringify(item));
			}
			return this.getItem(key);
		}
		catch (e) {
		}
	}

	getItem(key, defaultValue = null) {
		try {
			let itemStr = sessionStorage.getItem(key) || storage.getItem(key);
			if (itemStr) {
				return JSON.parse(itemStr);
			}
			else {
				return defaultValue;
			}
		}
		catch (e) {
			//console.log(e);
		}
	}

	removeItem(key) {
		storage.removeItem(key);
		sessionStorage.removeItem(key);
	}

}

AppStorage.$inject = ['$window'];


// WEBPACK FOOTER //
// ./modules/distribution/services/app_storage.js